import main from './main'
import customerNavItems from './customer-nav-items'

export default [...main]
export { customerNavItems }
